<template>
  <a
    href="#main"
    class="col-span-4 text-lightGreen text-base sm:col-span-6 md:col-span-6 flex flex-row items-center z-40 pointer-events-auto"
    @click.prevent="scrollToMain"
  >
    {{ $texts('hero.scrollToMain') }}
    <SpriteSymbol
      name="arrow-right"
      class="size-6 text-lightGreen transition-all duration-250 ease-in-out mr-1 group-hover:mr-0 rotate-90 ml-2"
    />
  </a>
</template>

<script lang="ts" setup>
const { $texts } = useNuxtApp()

const scrollToMain = () => {
  const mainElement = document.querySelector('#main')
  if (mainElement) {
    mainElement.scrollIntoView({ behavior: 'smooth' })
  }
}

defineOptions({
  name: 'SkipToMainContent',
})
</script>
